// @uni-kit/ui — product-neutral primitives. Tokens: "@uni-kit/ui/tokens.css". Brand themes: "@uni-kit/ui/theme".
import { formatBytes, formatDuration, formatRelativeTime, formatTimestamp } from "./format";

export { Button } from "./components/Button";
export type { ButtonProps, ButtonVariant } from "./components/Button";
export { Pill } from "./components/Pill";
export { StatusChip, defineStatusMap, statusStyle } from "./components/StatusChip";
export type { IconComponent, StatusMap, StatusStyle } from "./components/StatusChip";
export type { Tone } from "./components/tone";
export { Facts } from "./components/Facts";
export type { Fact } from "./components/Facts";
export { Panel } from "./components/Panel";
export { Tabs } from "./components/Tabs";
export type { TabItem } from "./components/Tabs";
export { List } from "./components/List";
export type { ListColumn, ListProps } from "./components/List";
export { EmptyState } from "./components/EmptyState";
export { Skeleton } from "./components/Skeleton";
export type { SkeletonShape } from "./components/Skeleton";
export { Meter } from "./components/Meter";
export { Freshness } from "./components/Freshness";
export type { FreshnessProps } from "./components/Freshness";
export { CapGate } from "./components/CapGate";
export { ConfirmRisk } from "./components/ConfirmRisk";
export type { Risk } from "./components/ConfirmRisk";
export { cx } from "./components/cx";

/** Formatters for bytes, durations (seconds) and times. `now` is always passed in. */
export const format = {
  bytes: formatBytes,
  duration: formatDuration,
  relative: formatRelativeTime,
  timestamp: formatTimestamp,
} as const;

export { Input, Select, SearchInput } from "./components/Field";
export { PageHeader } from "./components/PageHeader";
export { MetricCard } from "./components/MetricCard";
export { TableToolbar, ListFooter } from "./components/TableToolbar";
export type { SortingState as ListSorting, OnChangeFn as ListChangeHandler } from "@tanstack/react-table";
